<template>
  <div class="chat-query-by-event">
    <el-row :gutter="20">
      <!-- 设备类型选择 -->
      <el-col :span="4">
        <el-select v-model="osType" placeholder="请选择设备类型">
          <el-option label="iOS" value="ios"></el-option>
          <el-option label="Android" value="android"></el-option>
        </el-select>
      </el-col>
      <!-- 时间范围选择 -->
      <el-col :span="8">
        <el-date-picker v-model="dateRange" type="daterange" range-separator="至" 
          start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-col>
      <!-- 国家输入 -->
      <el-col :span="8">
        <el-input v-model="country" placeholder="国家代码(如:PH)" maxlength="2"></el-input>
      </el-col>
      
    </el-row>

    <el-row style="margin-top: 20px;" :gutter="20">
      <!-- 会员状态选择 -->
      <el-col :span="4">
        <el-select v-model="isVip" placeholder="会员状态">
          <el-option label="会员" :value="true"></el-option>
          <el-option label="非会员" :value="false"></el-option>
        </el-select>
      </el-col>
      <!-- 最少拍题次数 -->
      <el-col :span="6">
        <el-input-number v-model="photoMsgs1mon" :min="0" :controls="false" placeholder="最少拍题次数" style="width: 100%;"></el-input-number>
      </el-col>
      <!-- 最少对话轮次 -->
      <el-col :span="6">
        <el-input-number v-model="msgs1mon" :min="0" :controls="false" placeholder="最少对话轮次" style="width: 100%;"></el-input-number>
      </el-col>

      <!-- 学年段-->
      <el-col :span="4">
        <el-select v-model="gradeLevel" placeholder="学年段" style="width: 100%;" clearable>
          <el-option label="小学" value="小学"></el-option>
          <el-option label="初中" value="初中"></el-option>
          <el-option label="高中" value="高中"></el-option>
          <el-option label="大学" value="大学"></el-option>
          <el-option label="其他" value="其他"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4" style="display: flex; justify-content: flex-start;">
        <el-button type="primary" @click="queryUserList" icon="el-icon-search">查询</el-button>
      </el-col>
    </el-row>

    <el-divider></el-divider>

    <!-- 用户列表 -->
    <el-table v-if="!showUserDetail" :data="userProfiles" style="width: 100%">
      <el-table-column prop="uid" label="用户ID"></el-table-column>
      <el-table-column prop="country" label="国家"></el-table-column>
      <el-table-column prop="state" label="州"></el-table-column>
      <!-- 年级 -->
      <el-table-column prop="grade" label="年级"></el-table-column>
      <!-- 学年段 -->
      <el-table-column prop="grade_level" label="学年段"></el-table-column>
      <!-- 活跃平台 -->
      <el-table-column prop="os_type" label="活跃平台"></el-table-column>
      <!-- 版本 -->
      <el-table-column prop="app_version" label="版本"></el-table-column>
      <!-- 会员状态 -->
      <el-table-column prop="is_vip" label="会员状态">
        <template slot-scope="scope">
          {{ scope.row.is_vip ? '是' : '否' }}
        </template>
      </el-table-column>
      <!-- 订阅时间 -->
      <el-table-column prop="first_subscribe_date" label="订阅时间">
        <template slot-scope="scope">
          {{ formatDate(scope.row.first_subscribe_date) }}
        </template>
      </el-table-column>
      <!-- 当前付费状态 -->
      <el-table-column prop="pay_status" label="当前付费状态">
        <template slot-scope="scope">
          {{ scope.row.pay_status ? '付费' : '未付费' }}
        </template>
      </el-table-column>
      <!-- 付费类型 -->
      <el-table-column prop="pay_type" label="付费类型">
        <template slot-scope="scope">
          {{ scope.row.pay_type }}
        </template>
      </el-table-column>
      <!-- 首次付费日期 -->
      <el-table-column prop="first_pay_date" label="首次付费日期">
        <template slot-scope="scope">
          {{ formatDate(scope.row.first_pay_date) }}
        </template>
      </el-table-column>
      <!-- 首次付费类型 -->
      <el-table-column prop="first_pay_type" label="首次付费类型">
        <template slot-scope="scope">
          {{ scope.row.first_pay_type }}
        </template>
      </el-table-column>
      <!-- 注册时间 -->
      <el-table-column prop="register_date" label="注册时间">
        <template slot-scope="scope">
          {{ formatDate(scope.row.register_date) }}
        </template>
      </el-table-column>
      <!-- 活跃天数 -->
      <el-table-column prop="active_days_1_month" label="月活跃天数"></el-table-column>
      <!-- 月拍题次数 -->
      <el-table-column prop="photo_msgs_1mon" label="月拍题次数"></el-table-column>
      <!-- 月对话轮次 -->
      <el-table-column prop="msgs_1mon" label="月对话次数"></el-table-column>
      <!-- 操作 -->
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="handleUserDetail(scope.row.user_id)">对话记录</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 对话记录 -->
    <ChatHistoryDisplay v-else :userId="selectedUserId" :dateRange="userChatDateRange" showBackButton @back="showUserDetail = false" />

    <!-- 分页 -->
    <el-pagination 
      v-if="!showUserDetail"
      @current-change="handlePageChange"
      :current-page="currentPage"
      :page-size="15"
      :total="total"
      style="margin-top: 20px; text-align: right;">
    </el-pagination>
  </div>
</template>

<script>
import ChatHistoryDisplay from '@/components/ChatHistoryDisplay.vue';

export default {
  name: 'ChatQueryByEvent',
  components: {
    ChatHistoryDisplay
  },
  data() {
    return {
      showUserDetail: false,
      selectedUserId: '',
      osType: 'ios',
      dateRange: [],
      country: '',
      isVip: true,
      gradeLevel: '',
      photoMsgs1mon: undefined,
      msgs1mon: undefined,
      currentPage: 1,
      total: 0,
      userProfiles: [],
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          const twoMonthsAgo = new Date();
          twoMonthsAgo.setTime(twoMonthsAgo.getTime() - 3600 * 1000 * 24 * 60); // 60天前
          return time.getTime() > today.getTime() || time.getTime() < twoMonthsAgo.getTime();
        },
        shortcuts: [{
          text: '近1周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '近2周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '近1月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '近2月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  mounted() {
    // 设置默认时间范围为最近2周
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
    
    this.dateRange = [
      this.formatDate(start),
      this.formatDate(end)
    ];
    
    this.queryUserList();
  },
  computed: {
    // 最近30天
    userChatDateRange() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30); // 30天前
      
      return [
        this.formatDate(start),
        this.formatDate(end)
      ];
    }
  },
  methods: {
    handleUserDetail(userId) {
      this.selectedUserId = userId;
      this.showUserDetail = true;
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      if (typeof date === 'string') {
        date = new Date(date);
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async queryUserList() {

      let params = {
        os_type: this.osType,
        country: this.country,
        is_vip: this.isVip,
        photo_msgs_1mon: this.photoMsgs1mon,
        msgs_1mon: this.msgs1mon,
        grade_level: this.gradeLevel,
        page: this.currentPage - 1
      };

      if (this.dateRange && this.dateRange.length > 0) {
        params.start_time = new Date(this.dateRange[0]).toISOString();
        params.end_time = new Date(this.dateRange[1]).toISOString();
      }

      try {
        const res = await this.$http.post('/ams/message/user/list', params);
        const data = res.data.data || {};
        this.userProfiles = data.user_profiles || [];
        this.total = data.total || 0;
      } catch (error) {
        console.error('查询失败', error);
      }
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.queryUserList();
    }
  }
};
</script>

<style lang="less" scoped>
.chat-query-by-event {
  padding: 20px;
}
</style>
